import {
  SET_PORTAL_API, SET_PORTAL_SLIDESHOW,
  RESET_PORTAL, INCREMENT_SLIDE, DECREMENT_SLIDE,
  SET_PORTAL_OVERLAY
} from "../actions/portal_actions";
import { Portal } from "../../utils/constants";


const initialState = {
  portalType: Portal.Empty,
  portalVisible: false,
  title: '',
  text: '',
  images: [],
  index: 0
}

export const portalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PORTAL_API: {
      return {
        ...state,
        portalType: Portal.ApiResult,
        portalVisible: true,
        title: action.title,
        text: action.text
      }
    }
    case SET_PORTAL_SLIDESHOW: {
      return {
        ...state,
        portalType: Portal.Slideshow,
        portalVisible: true,
        images: [...action.images],
        index: action.index
      }
    }
    case DECREMENT_SLIDE: {
      return {
        ...state,
        index: (state.index === 0 ? state.images.length - 1 : state.index - 1)
      }
    }
    case INCREMENT_SLIDE: {
      return {
        ...state,
        index: (state.index === state.images.length - 1 ? 0 : state.index + 1)
      }
    }
    case SET_PORTAL_OVERLAY: {
      return {
        ...state,
        portalType: Portal.Overlay,
        portalVisible: true
      }
    }
    case RESET_PORTAL: {
      return {
        ...state,
        portalType: Portal.Empty,
        portalVisible: false,
        title: '',
        text: '',
        images: [],
        index: 0
      }
    }
    default: return state;
  }
}
